
export const ClosingYearMessage = {
    errorMessageClosingYearName: 'Closing Year Name Is Required',
    success: 'Success',
    ClosingYearSuccessMsg: 'Closing Year saved successfully...',
    updateClosingYearSuccessMsg: 'Closing Year updated successfully...',
    ClosingYearErrorMsg: 'Error occurred while saving Closing Year...',
    updatClosingYearErrorMsg: 'Error occurred while updating Closing Year...',
    deleteconfirmationMessage: 'Do you want to delete this Closing Year?',
    deleteHeader: 'Delete Confirmation',
    deleteCircleIcon: 'pi pi-info-circle',
    ClosingYearDeleteSuccessMsg: 'Closing Year Deleted successfully...',
    ClosingYearDeleteErrorMsg: 'Error occurred while deleting data...',
    error: 'Error',
    ClosingYearColSettngSuccessMsg: 'Closing Year column settings updated successfully...',
    ClosingYearColSettngErrorMsg: 'Error occurred while updating column settings...',
    warning: 'Warn',
} as const;

export const ClosingYearLockValue = {
    lockAR: "lockAR",
    lockAP: "lockAP",
    lockGL: "lockGL",
    lockPeriodClose: "lockPeriodClose",
    excludeOthers: "excludeOthers",
} as const;

export type typeClosingYearLock = keyof typeof ClosingYearLockValue;
export type typeClosingYearLockValue = (typeof ClosingYearLockValue)[keyof typeof ClosingYearLockValue];
